import { translate } from '../i18n'
import { StringValidator } from './StringValidator'

//eslint-disable-next-line
export const EXTERNAL_ID_REGEX = /^[a-zA-Z0-9]+[a-zA-Z0-9|\.|_|-]*$/

//eslint-disable-next-line
export const FIX_EXTERNAL_ID_REGEX = /[^a-zA-Z0-9\\.\\_\\-]+/g

export class ExternalIdValidator extends StringValidator {
    isValidString = (value: string) => {
        return EXTERNAL_ID_REGEX.test(value)
    }

    getMessage = () => translate('validations.external_id') as string
}
